<template>
  <div>
    <MainForm
      :name="FORM_NAMES.insuranceKYC"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="Insurance application"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.welcome"
        ui-title="Contact Information"
        ui-subtitle="We need to ask you a few questions to create your profile"
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetFullName :fieldset-name="FIELDSET_NAMES.fullNameReview" />
        <FieldsetEmail />
        <FieldsetMobilePhone title="Your mobile number is" />
      <FieldsetEmiratesIdNumber />
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.consent">
      <UiWrapper :name="FIELD_NAMES.consent">
        <CheckWrapper>
          <Expandable
            excerpt="I, hereby consent to..."
            :extra-text="`I, hereby consent to (i) leave Deem’s website, and get redirected to a 
            third party website. Deem makes no representations nor has any supervision or control over 
            the quality, content, reliability or security of the third party website, nor shall Deem be 
            liable for its use. (ii) have read and accept Deem’s Terms and Conditions.`"
          />
        </CheckWrapper>
      </UiWrapper>
    </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetEmiratesIdNumber from "@/forms/components/shared/fieldsets/emirates-id-number";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";

import FieldsetEmail from "@/forms/components/shared/fieldsets/email";

import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";

import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import {
  SET_BANK_NAME,
  SET_FIRST_NAME,
  SET_SECOND_NAME,
  SET_BASIC_ELIGIBILITY,
  SET_PRODUCT_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
  SET_VARIABLE_INCOME,
  SET_UAE_VINTAGE
} from "@/lib/constants/mutations";

import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";

export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    InputText,
    InputSlide,
    UiWrapper,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    CheckWrapper,
    Button,
    Expandable, 
    FieldsetEmiratesIdNumber

  },

  data: () => ({
    
   
  }),
   mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
methods:{
    finishCallback() {
    
      this.showEndPage({
        title: '',
        subtitle: 'Thank you for your interest . Our Team will get in touch with you Shortly.'
      });
    },
}
};
</script>

